// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3LUm_","dragIcon":"SortableItem_dragIcon__Egn_4","disabled":"SortableItem_disabled__12bqv"};